import { homecardsParser } from '../modules/parsers/homecards';

export default {
  HomecardsModule: homecardsParser
};
